<template>
	<div class="content">

		<div class="md-layout">
			<div class="md-layout-item md-medium-size-100 md-size-100">

				<md-card>
					<md-card-header data-background-color="purple">
						<h4 class="title">{{$route.name}}</h4>
						<!-- <p class="category">{{$route.name}}</p> -->
					</md-card-header>
					<md-card-content>
						<loading v-if="!loaded" />
						<el-tabs v-model="tabName" v-if="loaded">
							<el-tab-pane label="ការបង់ប្រាក់ជិតមកដល់" name="first"></el-tab-pane>
							<el-tab-pane label="ការបង់ប្រាក់ហួសកំណត់" name="second"></el-tab-pane>
							<el-tab-pane label="ការបង់ប្រាក់បានទូទាត់" name="third"></el-tab-pane>
							<!-- <el-tab-pane label="ស្វែងរកតាមកាលបរិច្ឆេទ" name="forth"></el-tab-pane> -->
						</el-tabs>



						<div v-if="tabName == 'first' && loaded">
							<loading v-if="!pendingLoaded" />
							<p v-if="pendingPaymentList.length == 0 && pendingLoaded">មិនមាន</p>
							<md-table v-if="pendingPaymentList.length > 0">
								<md-table-row>
									<md-table-head>ល.រ</md-table-head>
									<md-table-head>លេខកូដ</md-table-head>
									<md-table-head>អតិថិជន</md-table-head>
									<md-table-head>ថ្ងៃត្រូវបង់</md-table-head>
									<md-table-head>ប្រាក់ដើមត្រូវបង់</md-table-head>
									<md-table-head>ការប្រាក់ត្រូវបង់</md-table-head>
									<md-table-head>ប្រាក់ត្រូវបង់សរុប</md-table-head>
									<md-table-head>ស្ថានភាព</md-table-head>
									<md-table-head>សកម្មភាព</md-table-head>
								</md-table-row>

								<md-table-row v-for="(payment, index) in pendingPaymentList">
									<md-table-cell>{{ index + 1 }}</md-table-cell>
									<md-table-cell>{{ payment.hash }}</md-table-cell>
									<md-table-cell><b>ID: {{payment.client_hash}}</b> ({{ payment.name }})</md-table-cell>
									<md-table-cell>
										<span class="late" v-if="config.timelify(payment.due_date) == 'ហួសកំណត់'">{{ config.datelifyShort(payment.due_date) }}({{config.timelify(payment.due_date)}})</span>
										<span class="active" v-else>{{ config.datelifyShort(payment.due_date) }}({{config.timelify(payment.due_date)}})</span>
									</md-table-cell>
									<md-table-cell>{{ config.moneylify(payment.principal) }}</md-table-cell>
									<md-table-cell>{{ config.moneylify(payment.interest) }}</md-table-cell>
									<md-table-cell><b>{{ config.moneylify(payment.interest + payment.principal) }}</b>
									</md-table-cell>
									<md-table-cell>
										<span class="late">{{ config.getStatus(payment.status) }}</span>
									</md-table-cell>
									<md-table-cell>
										<router-link :to="'/loans/detail/' + payment.loan_hash">
											<md-button class="md-just-icon md-simple md-success">
												<md-icon>visibility</md-icon>
												<md-tooltip md-direction="top">បង្ហាញបន្ថែម</md-tooltip>
											</md-button>
										</router-link>
									</md-table-cell>
								</md-table-row>
							</md-table>
						</div>

						<div v-if="tabName == 'second'">
							<loading v-if="!lateLoaded" />
							<p v-if="latePaymentList.length == 0 && lateLoaded">មិនមាន</p>
							<md-table v-if="latePaymentList.length > 0">
								<md-table-row>
									<md-table-head>ល.រ</md-table-head>
									<md-table-head>លេខកូដ</md-table-head>
									<md-table-head>អតិថិជន</md-table-head>
									<md-table-head>ថ្ងៃត្រូវបង់</md-table-head>
									<md-table-head>ប្រាក់ដើមត្រូវបង់</md-table-head>
									<md-table-head>ការប្រាក់ត្រូវបង់</md-table-head>
									<md-table-head>ប្រាក់ត្រូវបង់សរុប</md-table-head>
									<md-table-head>ស្ថានភាព</md-table-head>
									<md-table-head>សកម្មភាព</md-table-head>
								</md-table-row>

								<md-table-row v-for="(payment, index) in latePaymentList">
									<md-table-cell>{{ index + 1 }}</md-table-cell>
									<md-table-cell>{{ payment.hash }}</md-table-cell>
									<md-table-cell><b>ID: {{payment.client_hash}}</b> ({{ payment.name }})</md-table-cell>
									<md-table-cell><span class="late">{{ config.datelifyShort(payment.due_date) }}({{config.timelify(payment.due_date)}})</span></md-table-cell>
									<md-table-cell>{{ config.moneylify(payment.principal) }}</md-table-cell>
									<md-table-cell>{{ config.moneylify(payment.interest) }}</md-table-cell>
									<md-table-cell><b>{{ config.moneylify(payment.interest + payment.principal) }}</b>
									</md-table-cell>
									<md-table-cell>
										<span class="late">{{ config.getStatus(payment.status) }}</span>
									</md-table-cell>
									<md-table-cell>
										<router-link :to="'/loans/detail/' + payment.loan_hash">
											<md-button class="md-just-icon md-simple md-success">
												<md-icon>visibility</md-icon>
												<md-tooltip md-direction="top">បង្ហាញបន្ថែម</md-tooltip>
											</md-button>
										</router-link>
									</md-table-cell>
								</md-table-row>
							</md-table>
						</div>

						<div v-if="tabName == 'third'">
							<loading v-if="!paidLoaded" />
							<p v-if="paidPaymentList.length == 0 && paidLoaded">មិនមាន</p>
							<md-table v-if="paidPaymentList.length > 0">
								<md-table-row>
									<md-table-head>ល.រ</md-table-head>
									<md-table-head>លេខកូដ</md-table-head>
									<!-- <md-table-head>អតិថិជន</md-table-head> -->
									<md-table-head>ថ្ងៃត្រូវបង់</md-table-head>
									<md-table-head>ថ្ងៃបានបង់</md-table-head>
									<md-table-head>ប្រាក់ដើមត្រូវបង់</md-table-head>
									<md-table-head>ការប្រាក់ត្រូវបង់</md-table-head>
									<md-table-head>ប្រាក់ត្រូវបង់សរុប</md-table-head>
									<md-table-head>ប្រាក់ពិន័យ</md-table-head>
									<md-table-head>ស្ថានភាព</md-table-head>
									<md-table-head>សកម្មភាព</md-table-head>
								</md-table-row>

								<md-table-row v-for="(payment, index) in paidPaymentList">
									<md-table-cell>{{ index + 1 }}</md-table-cell>
									<md-table-cell>{{ payment.hash }}<br><b>ID: {{payment.client_hash}}</b> ({{ payment.name }})</md-table-cell>
									<!-- <md-table-cell></md-table-cell> -->
									<md-table-cell>{{ config.datelifyShort(payment.due_date) }}</md-table-cell>
									<md-table-cell>{{ config.datelify(payment.paid_date) }}<br>{{payment.paid_by}}</md-table-cell>
									<md-table-cell>{{ config.moneylify(payment.principal) }}</md-table-cell>
									<md-table-cell>{{ config.moneylify(payment.interest) }}</md-table-cell>
									<md-table-cell><b>{{ config.moneylify(payment.interest + payment.principal) }}</b></md-table-cell>
									<md-table-cell>{{config.moneylify(payment.fine)}}</md-table-cell>
									<md-table-cell>
										<span class="active">{{ config.getStatus(payment.status) }}</span>
									</md-table-cell>
									<md-table-cell>
										<router-link :to="'/loans/detail/' + payment.loan_hash">
											<md-button class="md-just-icon md-simple md-success">
												<md-icon>visibility</md-icon>
												<md-tooltip md-direction="top">បង្ហាញបន្ថែម</md-tooltip>
											</md-button>
										</router-link>
									</md-table-cell>
								</md-table-row>
							</md-table>
						</div>

						<div v-if="tabName == 'forth'">
							<div class="md-layout">
								<div class="md-layout-item md-small-size-100 md-size-33">
									<md-field>
										<label>Payment Start Date</label>
										<md-input type="text" v-model="range.start_date" style="display:none" />
										<datetime type="date" v-model="range.start_date" auto></datetime>
									</md-field>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-33">

									<md-field>
										<label>Payment End Date</label>
										<md-input type="text" v-model="range.end_date" style="display:none" />
										<datetime type="date" v-model="range.end_date" auto></datetime>
									</md-field>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-33">
									<md-button class="md-raised md-primary" style="width:100%" @click="getData()">បង្ហាញ</md-button>
								</div>
							</div>
							<md-table v-if="rangePaymentList.length > 0">

							</md-table>
						</div>

					</md-card-content>
				</md-card>
			</div>
		</div>
	</div>
</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: {
			Datetime
		},
		data() {
			return {
				tabName: "first",
				loaded: true,
				range:{
					start_date: "",
					end_date: ""
				},
				pendingLoaded: false,
				pendingPaymentList: [],
				paidLoaded: false,
				paidPaymentList: [],
				lateLoaded: false,
				latePaymentList: [],
				rangePaymentList: [],
				showPaid: false,
				showPending: false,
				showLate: false
			}
		},
		created() {
			this.getPending();
			this.getPaid();
			this.getLate();
		},
		methods: {
			showPaidAction() {
				this.showPaid = !this.showPaid
			},
			showLateAction() {
				this.showLate = !this.showLate
			},
			showPendingAction() {
				this.showPending = !this.showPending
			},
			getLate(offset = 0, replace = true) {
				this.$http.get(this.config.api + "/admin/loan/get_late_payment").then(data => {
					this.latePaymentList = data.body.data
					this.lateLoaded = true
				})
			},
			getPending(offset = 0, replace = true) {
				this.$http.get(this.config.api + "/admin/loan/get_monthly_pending_payment").then(data => {
					this.pendingPaymentList = data.body.data
					this.pendingLoaded = true
				})
			},
			getPaid(offset = 0, replace = true) {
				this.$http.get(this.config.api + "/admin/loan/get_monthly_paid_payment").then(data => {
					this.paidPaymentList = data.body.data
					this.paidLoaded = true
				})
			},
			getData() {
				let start_date = (new Date(this.range.start_date)).getTime();
				let end_date = (new Date(this.range.end_date)).getTime();

				this.$http.get(this.config.api + "/admin/loan/get_payment_by_range/" + start_date + "/" + end_date).then(data => {
					this.rangePaymentList = data.body.data
				});
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Calendar.vue